<template>
  <v-card class="pa-4">
    <div v-if="done">
      <div v-if="error">
        <v-alert dense outlined type="error">
          Algo deu errado. Tente novamente mais tarde.
        </v-alert>
      </div>
      <div v-else>
        <p class="text-body-2 font-weight-bold">Operação realizada!</p>
        <p v-if="removed.length > 0 || updated.length > 0" class="text-body-2">
          Relatório das modificações:
        </p>
        <div v-if="removed.length > 0">
          <p class="text-body-2 font-weight-bold">
            As turmas a seguir foram removidas pois não foram
            ofertadas para o período informado:
          </p>
          <p
            class="text-caption"
            v-for="(item, i) in removed"
            v-bind:key="i"
          >
            {{ item }}
          </p>
        </div>
        <div v-if="updated.length > 0">
          <p class="text-body-2 font-weight-bold">
            Turmas atualizadas:
          </p>
          <p
            class="text-caption"
            v-for="(item, i) in updated"
            v-bind:key="i"
          >
            {{ item }}
          </p>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="variant == 'full'" class="text-center">
        <p class="text-body-2 font-weight-bold">
          Aguarde. Estamos atualizando todos os dados!
        </p>
        <v-progress-linear
          color="primary"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
        <p class="text-caption">{{ display }}</p>
      </div>
      <div v-else>
        <p class="text-body-2 font-weight-bold">
          Aguarde. Estamos copiando todos os dados!
        </p>
        <v-progress-linear
          color="primary"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "HandleFeedbackUpdateLink",
  props: {
    removed: Array,
    updated: Array,
    done: Boolean,
    error: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: "default"
    }
  },
  data() {
    return {
      display: "Carregando.",
      option: [
        "Buscando dandos do SIGAA.",
        "Verificando se as turmas estão disponíveis.",
        "Verificando alterações.",
        "Carregando."
      ],
      i: 0
    };
  },
  mounted() {
    setInterval(() => {
      this.display = this.option[this.i % this.option.length];
      this.i++;
    }, 2000);
  }
};
</script>
